import { CHANGE_THEME } from '../constants/themeConstant';

export const themeReducer = (state = {}, action) => {
  switch (action.type) {
    case CHANGE_THEME:
      return { ...state, isdark: action.payload };
    default:
      return state;
  }
};
